import React, {Component} from 'react';
import {
  withRouter, Link
} from 'react-router-dom';
import {connect} from 'react-redux';

// CSS
import style from '../../Styles/Components/CameraFooter.module.css';


class FooterView extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className={style.cameraFooterArea}>
        <div onClick={()=>{console.log("인증내역")}} className={style.footerDiv}>
          <img src={"https://d15eixcc3515pq.cloudfront.net/Assets/img/ic-history.svg"} className={style.ic_footer}/>
          <span className={style.font}>인증내역</span>
        </div>
        <div onClick={()=>{console.log("셔터")}} className={style.centerDiv}>
          <img src={"https://d15eixcc3515pq.cloudfront.net/Assets/img/nav-scan.svg"} className={style.icon}/>
        </div>
        <div onClick={()=>{console.log("설정")}} className={style.footerDiv}>
          <img src={"https://d15eixcc3515pq.cloudfront.net/Assets/img/ic-setting.svg"} className={style.ic_footer}/>
          <span className={style.font}>설정</span>
        </div>
      </div>
    );
  }
}

export default connect()(withRouter(FooterView));